angular.module('properties.dataCollectors').factory('DataCollectorList', function () {
    return {
        get: function (DataStore, building) {
            var inflate = 'buildings,childCollectors,childCollectors.childCollectors,childCollectors.childCollectors.childCollectors';
            return DataStore.getList(building, 'collectors', { inflate: inflate });
        }
    }
})
